<template>
  <div :class="xAxis ? ' axis-info-x' : 'axis-info-y'">
    <svgicon :name="icon" width="16" height="16" color="white"></svgicon>
    <p :class="xAxis ? 'axis-info-x__label' : 'axis-info-y__label'">
      {{ label }}
    </p>
  </div>
</template>

<script>
export default {
  name: "ScatterAxisInfo",
  props: ["icon", "label", "xAxis"],
};
</script>

<style lang="scss" scoped>
.axis-info-x {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(0, -50%);
  display: flex;
  align-items: center;
  @include dida-S;

  &__label {
    color: white;
    margin-left: toRem(5);
  }
}

.axis-info-y {
  @extend .axis-info-x;
  top: toRem(20);
  left: toRem(55);

  &__label {
    @extend .axis-info-x__label;
  }
}
</style>
